class FilterForm extends HTMLElement {
    constructor() {
        super();

        this.urlDefault = "https://app.ganpei.com.hk/api/online-store/";
        this.urlSettings = this.urlDefault + "settings";
        this.urlProducts = this.urlDefault + "products";
        this.urlAddCart = this.urlDefault + "add-to-cart";
        this.urlDownload = this.urlDefault + "products-to-download";
        this.currentPage = 1;

        this.section = this.closest(".shopify-section");
        this.sectionMain = this.closest(".js-filter-api");

        this.elmString = this.elmIcon || this.querySelector("#setElement").textContent;
        this.elm = JSON.parse(this.elmString);

        this.btnSubmit = this.section.querySelector(".js-filter-submit");
        this.pagination = this.section.querySelector(".js-filter-api-pagination");
        this.resultsContainer = this.section.querySelector(".js-results-container");
        this.backBtn = this.section.querySelector(".js-back-to-search");
        this.backList = this.section.querySelector(".js-back-list");
        this.form = this.section.querySelector(".js-filter-form");

        this.sectionId = this.dataset.sectionId;
        this.currentTemplate = this.dataset.template;
        this.redirect = this.dataset.redirect === "true" && this.dataset.pageRedirect.length > 0 ? true : false;
        this.redirectUrl = this.dataset.pageRedirect;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.section.querySelector(".js-filter-clear").addEventListener("click", this.clearFilter.bind(this));
        this.section.querySelector(".js-btn-toggle").addEventListener("click", this.toggleHeight.bind(this));
        this.backBtn &&
            this.backBtn.addEventListener("click", () => {
                document.body.classList.remove("showing-results");
                this.sectionMain.classList.remove("show-results");
                this.backBtn.classList.add("hidden");
                let position = this.closest(".filter-container").offsetTop + 110;
                this.backList && this.backList.classList.remove("hidden");
                // window.scrollTo({
                //     top: position,
                //     left: 0,
                //     behavior: "smooth",
                // });
            });
        this.backList &&
            this.backList.addEventListener("click", (e) => {
                document.body.classList.add("showing-results");
                this.sectionMain.classList.add("show-results");
                this.backBtn.classList.remove("hidden");
            });

        this.downloadBtn = this.section.querySelector(".js-download-btn");
        this.downloadBtn && this.downloadBtn.addEventListener("click", this.downloadResults.bind(this));
        this.scrollToSection();
        this.init();
    }

    async init() {
        this.dataSettings = await this.getFilterData();
        await this.setFilterData();
        let hasSearchUrl = await this.checkURL();
        if (this.redirect) {
            await this.clearFilter();
            let formData = new FormData(this.querySelector("form"));
            formData = this.handleValueForm(formData);
            formData.append("page", 1);
            const searchParams = new URLSearchParams(formData).toString();
            await this.renderPage(searchParams, formData, event);
        } else {
            hasSearchUrl && (await this.autoFilter());
        }
    }

    getFilterData() {
        return fetch(this.urlSettings)
            .then((response) => response.json())
            .then((data) => data);
    }

    setFilterData() {
        for (const [key, value] of Object.entries(this.dataSettings)) {
            let elm = this.querySelector(`[name="${key}"]`);
            if (elm) {
                if (elm.tagName == "SELECT") value.forEach((val) => (elm.innerHTML += `<option value="${val}">${val}</option>`));
                if (elm.tagName == "INPUT") {
                    this.querySelectorAll("[data-set-max]").forEach((el) => (el.max = value)); // order 1
                    this.querySelector(`[name="${key}"]`).value = value; // order 2
                    this.querySelector("price-range") && this.querySelector("price-range").reCheckPrice(); // order 3
                }
            }
        }
    }

    autoFilter() {
        if (this.currentTemplate == "collection" || window.innerWidth >= 990) this.btnSubmit.click();
    }

    async checkURL() {
        let searchUrl = window.location.search;
        if (searchUrl.length == 0) return true;
        let getSearchParams = new URLSearchParams(searchUrl);
        const changeEvent = new Event("change");
        const inputEvent = new Event("input");
        let searchHaveNotElm = [];
        let searchHaveElm = [];
        for (const [key, value] of getSearchParams) {
            let elm = this.section.querySelector(`[name="${key}"]`);
            if (elm) {
                elm.value = value;
                if (!elm.closest("triger-filter")) {
                    elm.dispatchEvent(changeEvent);
                    elm.dispatchEvent(inputEvent);
                }
                searchHaveElm.push([key, value]);
            } else searchHaveNotElm.push([key, value]);
        }
        if (searchHaveElm.length == 0 && searchHaveNotElm.length == 0) return true;
        let formData = new FormData(this.form);
        formData = this.handleValueForm(formData);

        searchHaveNotElm.forEach((searchAr) => formData.append(searchAr[0], searchAr[1]));

        if (filtelSearchValue("collections") && !formData.has("collections")) formData.append("collections", filtelSearchValue("collections"));

        const searchParams = new URLSearchParams(formData).toString();
        await this.renderPage(searchParams, formData, event);
        return await false;
    }

    async onSubmitHandler(event) {
        event.preventDefault();
        let formData = new FormData(this.querySelector("form"));
        formData = this.handleValueForm(formData);
        if (event.target.name != "page") formData.append("page", 1);

        if (this.redirect) {
            formData.delete("collections");
            const searchParams = new URLSearchParams(formData).toString();
            window.location.href = `${this.redirectUrl}?${searchParams}`;
            return;
        }
        const searchParams = new URLSearchParams(formData).toString();
        await this.renderPage(searchParams, formData, event);
        return;
    }

    handleValueForm(formData) {
        let clearKey = Array.from(formData.entries()).filter((item) => {
            let key = item[0];
            let value = item[1];
            let elmTagname = document.querySelector(`.js-filter-api [name="${key}"]`).tagName;
            if ((value.toUpperCase() == "ALL" && elmTagname == "SELECT") || value.trim().length == 0) return item;
            if (key == "priceMin" && Number(value) == 0) return item;
            if (key == "priceMax" && Number(value) == this.dataSettings.priceMax) return item;
        });
        clearKey.forEach(([key, value]) => formData.delete(key));
        return formData;
    }

    async renderPage(searchParams, formData, event) {
        if (!this.resultsContainer) return;
        const searchUrl = `${this.urlProducts}?${searchParams}`;
        this.currentPage = Number(formData.get("page")) || 1;
        this.showLimit = Number(formData.get("pageSize"));
        let response = await fetch(searchUrl);
        let dataProduct = await response.json();
        this.totalProduct = await dataProduct.totalResults;
        if (dataProduct.productsData.length > 0) {
            this.resultsContainer.classList.remove("is--empty");
            await this.buildItem(dataProduct.productsData);
            await this.buildPagination(dataProduct);
            await this.buildTitle(dataProduct);
            if (event && event.target.name == "page") await this.scrollTop(this.section.offsetTop);
        } else {
            this.resultsContainer.classList.add("is--empty");
        }
        await this.updateURL(searchParams);
        await this.resultsContainer.classList.remove("hidden");
        (await !this.redirect) && document.body.classList.add("showing-results");
        await this.sectionMain.classList.add("show-results");
        (await this.backBtn) && this.backBtn.classList.remove("hidden");
        (await this.backList) && this.backList.classList.add("hidden");
    }

    updateURL(searchParams) {
        window.history.pushState({}, "", `${window.location.pathname}?${searchParams}`);
    }

    scrollTop(position = 0) {
        window.scrollTo({
            top: position,
            left: 0,
            // behavior: "smooth",
        });
    }

    buildPagination(dataProduct) {
        // Get page info
        let currentPage = parseInt(this.currentPage);
        let totalPage = Math.ceil(this.totalProduct / this.showLimit);
        // If it has only one page, clear Pagination
        if (totalPage <= 1) {
            this.pagination.innerHTML = "";
            return;
        }

        let paginationHtml = this.elm.pagination;
        // Build Previous
        let previousHtml =
            currentPage > 1
                ? `<li><triger-filter>
                <label class="text-label" for="pagi-item-prev">
                <input type="checkbox" name="page" form="filter-api-${this.sectionId}" value="{pagiUrl}" id="pagi-item-prev"/><</label>
                </triger-filter></li>`
                : ``;
        previousHtml = previousHtml.replace(/{pagiUrl}/g, currentPage - 1);
        paginationHtml = paginationHtml.replace(/{previous}/g, previousHtml);
        // Build Next
        let nextHtml =
            currentPage < totalPage
                ? `<li><triger-filter>
                <label class="text-label" for="pagi-item-next">
                <input type="checkbox" name="page" form="filter-api-${this.sectionId}" value="{pagiUrl}" id="pagi-item-next"/>></label>
                </triger-filter></li>`
                : ``;
        nextHtml = nextHtml.replace(/{pagiUrl}/g, currentPage + 1);
        paginationHtml = paginationHtml.replace(/{next}/g, nextHtml);
        // Build First
        let firstHtml =
            currentPage > 1 && totalPage > 4
                ? `<li><triger-filter>
                <label class="text-label" for="pagi-item-first">
                <input type="checkbox" name="page" form="filter-api-${this.sectionId}" value="1" id="pagi-item-first"/>|<</label>
                </triger-filter></li>`
                : ``;
        firstHtml = firstHtml.replace(/{pagiUrl}/g, currentPage + 1);
        paginationHtml = paginationHtml.replace(/{first}/g, firstHtml);
        // Build Last
        let lastHtml =
            currentPage < totalPage && totalPage > 4
                ? `<li><triger-filter>
                <label class="text-label" for="pagi-item-last">
                <input type="checkbox" name="page" form="filter-api-${this.sectionId}" value="${totalPage}" id="pagi-item-last"/>>|</label>
                </triger-filter></li>`
                : ``;
        lastHtml = lastHtml.replace(/{pagiUrl}/g, currentPage + 1);
        paginationHtml = paginationHtml.replace(/{last}/g, lastHtml);

        // Create page items array
        let beforeCurrentPageArr = [];
        for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) beforeCurrentPageArr.unshift("...");
        if (currentPage - 4 >= 0) beforeCurrentPageArr.unshift(1);
        beforeCurrentPageArr.push(currentPage);

        let afterCurrentPageArr = [];
        for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) afterCurrentPageArr.push("...");
        if (currentPage + 3 <= totalPage) afterCurrentPageArr.push(totalPage);
        // Build page items
        let pageItemsHtml = "";
        let pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (let iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == "...") pageItemsHtml += `<li><label class="text-label">{pagiUrl}</label></li>`;
            else {
                pageItemsHtml +=
                    pageArr[iPage] == currentPage
                        ? `<li class="pagi-active"><label class="text-label">{pagiUrl}</label></li>`
                        : `<li><triger-filter>
                        <label class="text-label" for="pagi-item-{pagiUrl}">
                        <input type="checkbox" name="page" form="filter-api-${this.sectionId}" value="{pagiUrl}" id="pagi-item-{pagiUrl}"/>{pagiUrl}</label>
                        </triger-filter></li>`;
            }
            pageItemsHtml = pageItemsHtml.replace(/{pagiUrl}/g, pageArr[iPage]);
        }
        paginationHtml = paginationHtml.replace(/{pageItems}/g, pageItemsHtml);
        this.pagination.innerHTML = paginationHtml;
    }

    buildTitle(dataProduct) {
        let total = dataProduct.totalResults;
        let smaller, bigger;
        switch (this.currentPage) {
            case 1:
                smaller = 1;
                bigger = Math.min(dataProduct.productsData.length, total);
                break;
            default:
                smaller = (this.currentPage - 1) * this.showLimit + 1;
                bigger = Math.min(this.currentPage * this.showLimit, total);
                break;
        }

        this.section.querySelector(`.js-result-title`).textContent = `Showing ${smaller} to ${bigger} of ${total}`;
        this.section.querySelector(`.js-result-title-footer`).textContent = `Showing ${smaller} to ${bigger} of ${total} (${Math.ceil(
            this.totalProduct / this.showLimit
        )} Pages)`;
    }

    buildItem(productsData) {
        let html = "";
        const buildRatingItem = (product) => {
            let count = 0;
            if (product.wa) count++;
            if (product.ws) count++;
            return `${product.wa} ${count == 2 ? "/" : ""} ${product.ws}`;
        };
        const buildAvailabilityItem = (product) => {
            if (!product.availability) return "";
            return `${product.availability > 20 ? "20+" : product.availability}`;
        };
        const buildIcon = (product) => {
            switch (product.style) {
                case "Red":
                    return this.elm.red_fat;
                case "White":
                    return this.elm.yellow_fat;
                case "Cham":
                    return this.elm.yellow_thin;
                case "Rose":
                    return this.elm.rose_thin;
                default:
                    return "";
            }
        };
        const maxQty = (product) => {
            return product.variants.reduce((total, variant) => total + variant.quantity, 0);
        };

        productsData.forEach((product, index) => {
            if (product.availability > 0) {
                let itemHtml = this.elm.item;
                itemHtml = itemHtml.replace(/{iconGlass}/g, buildIcon(product));
                itemHtml = itemHtml.replace(/{availabilityText}/g, buildAvailabilityItem(product));
                itemHtml = itemHtml.replace(/{availability}/g, product.availability);
                itemHtml = itemHtml.replace(/{format}/g, product.format);
                itemHtml = itemHtml.replace(/{name}/g, product.name);
                itemHtml = itemHtml.replace(/{unitOfSale}/g, product.unitOfSale);
                itemHtml = itemHtml.replace(/{vintage}/g, product.vintage);
                itemHtml = itemHtml.replace(/{country}/g, product.country);
                itemHtml = itemHtml.replace(/{region}/g, product.region);
                itemHtml = itemHtml.replace(/{rating}/g, buildRatingItem(product));
                itemHtml = itemHtml.replace(/{id}/g, product.id);
                itemHtml = itemHtml.replace(/{index}/g, index);
                itemHtml = itemHtml.replace(/{maxQty}/g, maxQty(product));
                itemHtml = itemHtml.replace(/{price_per_btl}/g, product.price_per_btl);
                html += itemHtml;
            }
        });
        this.section.querySelector(`.js-filter-table-items`).innerHTML = html;
    }

    clearFilter() {
        this.querySelectorAll("select").forEach((select) => (select.selectedIndex = 0));
        this.querySelectorAll('input:not([type="range"]):not([name="collections"])').forEach((input) => (input.value = ""));
        this.querySelector("#rangeMin").value = this.querySelector("#rangeMin").min;
        this.querySelector("#rangeMax").value = this.querySelector("#rangeMax").max;
        this.querySelector("#thumbMin").style.left = "0%";
        this.querySelector("#thumbMax").style.left = "100%";
        this.querySelector("#line").style.right = "0%";
        this.querySelector("#line").style.left = "0%";
        this.querySelector("#labelMin").textContent = this.querySelector("#rangeMin").min;
        this.querySelector("#labelMax").textContent = this.querySelector("#rangeMax").max;
        if (this.redirect == false && window.innerWidth >= 990) this.btnSubmit.click();
    }

    toggleHeight(e) {
        e.target.classList.toggle("opened");
        this.querySelector(".js-toggle-height").classList.toggle("closed");
    }

    downloadResults() {
        let formData = new FormData(this.form);
        formData = this.handleValueForm(formData);
        const searchParams = new URLSearchParams(formData).toString();
        const searchUrl = `${this.urlDownload}?${searchParams}`;
        fetch(searchUrl)
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    let arrayTitle = ["Type","Region", "Vintage", "Wine", "Rating (WA/WS)", "Packing", "Unit of Sale", "Availability", "HKD/btl"];
                    let csvContent = `sep=;\nAll wines are offered subject to remaining unsold and to final confirmation;\n${arrayTitle.join(";")}\n`;
                    data.forEach((item, index) => {
                        const ratingWa = item.wa ? item.wa : "N/A";
                        const ratingWs = item.ws ? item.ws : "N/A";
                        let rating = ratingWa + " / " + ratingWs;
                        let row = [
                            item.style ? formatString(item.style) : "",
                            item.region ? formatString(item.region) : "",
                            item.vintage ? formatString(item.vintage) : "",
                            item.name ? formatString(item.name) : "",
                            rating ? formatString(rating) : "",
                            item.format ? formatString(item.format) : "",
                            item.unitOfSale ? formatString(item.unitOfSale) : "",
                            item.availability ? formatString(item.availability) : "",
                            item.price_per_btl ? formatString(item.price_per_btl) : "",
                        ];
                        csvContent += row.join(";") + "\n";
                    });
                    let hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
                    hiddenElement.target = "_blank";

                    //provide the name for the CSV file to be downloaded
                    hiddenElement.download = "ProductResults.csv";
                    hiddenElement.click();
                }
            });
        const formatString = (input) => {
            return input.toString().replace(/(\r\n|\n|\r)/gm, "");
        };
    }
    scrollToSection() {
        let hookSearch = document.getElementById("js-search-filter-api");
        if (!hookSearch) return;
        hookSearch.removeAttribute("hidden");
        hookSearch.addEventListener("click", (e) => {
            e.preventDefault;
            let headerHeight = document.getElementById("HeaderWrapper") ? document.getElementById("HeaderWrapper").clientHeight : 0;
            let position = this.section.offsetTop - headerHeight - 20;
            window.scrollTo({
                top: position,
                left: 0,
                behavior: "smooth",
            });
        });
    }
}

customElements.define("filter-form", FilterForm);

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.rangMin = this.querySelector("#rangeMin");
        this.rangMax = this.querySelector("#rangeMax");

        this.thumbMin = this.querySelector("#thumbMin");
        this.thumbMax = this.querySelector("#thumbMax");
        this.line = this.querySelector("#line");

        this.labelMin = this.querySelector("#labelMin");
        this.labelMax = this.querySelector("#labelMax");

        this.dataPrice = {
            min: Number(this.rangMin.min),
            max: Number(this.rangMax.max),
        };
    }

    reCheckPrice() {
        this.dataPrice = {
            min: Number(this.rangMin.min),
            max: Number(this.rangMax.max),
        };

        // this.labelMax.textContent = theme.Currency.formatMoney(this.dataPrice.max, "{{amount_with_comma_separator}}");
        this.labelMax.textContent = this.dataPrice.max;

        this.querySelectorAll('input[type="range"]').forEach((element) => element.addEventListener("input", this.onChangeSlide.bind(this)));

        this.querySelectorAll('input[type="range"]').forEach((element) => element.addEventListener("change", this.endChangeSlide.bind(this)));
        this.rangeSetMinAndMaxValues();
    }

    onChangeSlide(event) {
        let val = Number(event.target.value);
        if (event.target.id == "rangeMin") {
            if (val > Number(this.rangMax.value)) return;
            this.thumbMin.style.left = this.calcLeftPosition(val) + "%";
        } else {
            if (val < Number(this.rangMin.value)) return;
            this.thumbMax.style.left = this.calcLeftPosition(val) + "%";
        }
        this.line.style.cssText = `left: ${this.calcLeftPosition(this.rangMin.value)}%;right: ${100 - this.calcLeftPosition(this.rangMax.value)}%;`;
        this.querySelector(`#${event.target.dataset.label}`).textContent = val;
    }

    calcLeftPosition(value) {
        value = Number(value);
        return (100 / (this.dataPrice.max - this.dataPrice.min)) * (value - this.dataPrice.min);
    }

    endChangeSlide(event) {
        let val = Number(event.target.value);
        if (event.target.id == "rangeMin") {
            if (val >= Number(this.rangMax.value)) event.target.value = Number(this.rangMax.value);
        } else {
            if (val <= Number(this.rangMin.value)) event.target.value = Number(this.rangMin.value);
        }
        this.rangMin.classList.remove("up");
        this.rangMax.classList.remove("up");
        event.target.classList.add("up");
        this.querySelector(`#${event.target.dataset.label}`).textContent = event.target.value;
    }

    rangeSetMinAndMaxValues() {
        this.thumbMin.style.left = this.calcLeftPosition(this.rangMin.value) + "%";
        this.thumbMax.style.left = this.calcLeftPosition(this.rangMax.value) + "%";
        this.line.style.cssText = `left: ${this.calcLeftPosition(this.rangMin.value)}%;right: ${100 - this.calcLeftPosition(this.rangMax.value)}%;`;
        Number(this.rangMin.value) <= this.dataPrice.min ? this.rangMax.classList.add("up") : this.rangMax.classList.remove("up");
        Number(this.rangMax.value) >= this.dataPrice.max ? this.rangMin.classList.add("up") : this.rangMin.classList.remove("up");
    }
}

customElements.define("price-range", PriceRange);

class TrigerFilter extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.change = this.querySelector("select") || this.querySelector("input");
        this.change.addEventListener("change", this.changeData.bind(this));
        this.filter = this.closest(".js-filter-api").querySelector("filter-form");
    }

    async changeData(event) {
        await this.classList.add("loading");
        await this.filter.onSubmitHandler(event);
        await this.classList.remove("loading");
    }
}

customElements.define("triger-filter", TrigerFilter);

class FilterAdd extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.getItemBundle.bind(this));
        this.btn = this.querySelector('[type="submit"]');
        this.soldOut = Number(this.form.dataset.availability) == 0 ? true : false;
        if (this.soldOut) {
            this.btn.disabled = true;
            this.btn.textContent = "Sold out";
        }
        this.nameProperties = "_id-bundle";
    }
    async getItemBundle(e) {
        e.preventDefault();
        this.btn.classList.add("loading");
        let formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData).toString();
        const form = e.target.closest(".js-filter-api").querySelector("filter-form");
        let id = Number(formData.get("id"));
        let propertiesUnitOfSale = this.form.dataset.unitofsale;
        let propertiesVintage = this.form.dataset.vintage;
        let propertiesPricePerBt = this.form.dataset.priceperbtl;
        let dataCart = await this.cartData();
        await fetch(`${form.urlAddCart}?${searchParams}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataCart),
        })
            .then((response) => response.json())
            .then((dataBundle) => {
                let propertiesName = this.nameProperties;
                let currentQty = dataCart.items
                    .filter((item) => Number(item.properties[propertiesName]) == Number(id))
                    .reduce((count, item) => (count = count + item.quantity), 0);
                let convertData = dataBundle.map((data) => {
                    let newQty = currentQty + data.quantity > 20 ? Math.min(20 - currentQty, data.quantity) : data.quantity;
                    currentQty = currentQty + newQty;
                    if (newQty <= 0) return;
                    return {
                        variantId: data.variantId,
                        quantity: newQty,
                        properties: {
                            [propertiesName]: id,
                            Vintage: propertiesVintage,
                            "Unit of Sale": propertiesUnitOfSale,
                            "HKD/btl": propertiesPricePerBt,
                        },
                    };
                });
                convertData = convertData.filter((element) => element !== undefined);
                this.addItem(convertData);
            })
            .catch((e) => {
                console.error(e);
            });
    }
    addItem(data) {
        let btn = this.btn;
        if (data.length == 0) {
            this.alertMaxium(Math.min(20, Number(this.form.dataset.availability)));
            theme.settings.cartType == "dropdown" && document.querySelector("#HeaderCartTrigger").click();
            btn.classList.remove("loading");
            return;
        }
        let formData = {
            items: data.map((item) => {
                return {
                    id: item.variantId,
                    quantity: item.quantity,
                    properties: item.properties,
                };
            }),
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                return response.json();
            })
            .then(async (cartItem) => {
                if (cartItem.status == 422) return alert(cartItem.description);
                try {
                    document.dispatchEvent(
                        new CustomEvent("ajaxProduct:added", {
                            detail: {
                                product: cartItem,
                                addToCartBtn: btn,
                            },
                        })
                    );
                } catch (e) {
                    console.error(e);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            })
            .finally(() => {
                btn.classList.remove("loading");
            });
    }

    alertMaxium(numberMax) {
        let html = `<div><h4>Update quantity</h4><p>You can't add more than ${numberMax}</p></div>`;
        buildPopup(html, "qty-popup");
    }

    cartData() {
        return fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((e) => e);
    }
}

customElements.define("filter-add", FilterAdd);

class FilterQuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        if (Number(this.input.dataset.availability) == 0) {
            this.querySelectorAll("button").forEach((button) => (button.disabled = true));
            this.input.value = 0;
            this.input.disabled = true;
            return;
        }
        this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.input.addEventListener("keypress", this.onInputNumber.bind(this));
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.value++ : this.input.value--;
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    onInputNumber(e) {
        if ((e.which != 8 && e.which != 0 && e.which < 48) || e.which > 57) e.preventDefault();
    }

    onInputChange(event) {
        let minNumber = Math.min(Number(event.target.max), 20);
        let isMaxCase = minNumber < 20 ? false : true;
        if (Number(event.target.value) > minNumber) {
            event.target.value = minNumber;
            this.alertMaxium(event.target, isMaxCase);
        }
        if (Number(event.target.value) < 1) event.target.value = 1;
    }
    alertMaxium(target, maxCase) {
        let text = maxCase ? `For orders over 20 cases, please contact us` : `Order cannot exceed more than ${target.value}`;
        let textFull = `<div><h4>Update quantity</h4><p>${text}</p></div>`;
        buildPopup(textFull, "qty-popup");
    }
}

customElements.define("filter-quantity", FilterQuantityInput);

async function buildPopup(content, className) {
    let elm = document.createElement("div");
    elm.classList.add("zoom-popup", "hidden", className);
    elm.innerHTML = `<div class="zoom-background js-close"></div>
                        <div class="zoom-container text-center">
                            <button class="js-close zoom-btn" style="font-weight: 700;">X</button>
                            ${content}
                        </div>`;
    document.body.append(elm);

    elm.querySelectorAll(".js-close").forEach((btn) => btn.addEventListener("click", () => elm.remove()));

    let img = elm.querySelector("img");
    img && (await loadImage(img.src, img));
    await elm.classList.remove("hidden");
}

async function loadImage(url, elem) {
    return new Promise((resolve, reject) => {
        elem.onload = () => resolve(elem);
        elem.onerror = reject;
        elem.loading = "auto";
        elem.src = url;
    });
}

function filtelSearchValue(key) {
    let searchParams = window.location.search;
    if (searchParams.length == 0) return false;
    return searchParams
        .substring(1)
        .split("&")
        .find((str) => {
            let arrStr = str.split("=");
            if (arrStr[1] == key) return;
        });
}
